import TrailCardV1 from '@alltrails/shared/components/TrailCard';
import useFeatures from '@alltrails/features/hooks/useFeatures';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import logTrailCardClicked from '@alltrails/amplitude/events/logTrailCardClicked';
import { TrailSearchResult } from '@alltrails/search/types/algoliaResultTypes';
import logSaveClicked from '@alltrails/amplitude/events/logSaveClicked';
import { trailFromAlgoliaTrail } from '@alltrails/trails';
import { useSelector } from '../../redux';

type TrailHoverCardProps = {
  result: TrailSearchResult;
  isFavorite: boolean;
  isCompleted: boolean;
  isVerified: boolean;
  handleFavoriteClick: () => void;
};

const TrailHoverCard = ({ result, isFavorite, isCompleted, isVerified, handleFavoriteClick }: TrailHoverCardProps) => {
  const displayMetric = useSelector(state => state.context.displayMetric);
  const languageRegionCode = useLanguageRegionCode();
  const isRoundEstTimeToCompletionEnabled = useFeatures()?.includes('round_est_time_completion');
  const showStrenuousDifficultyLevel = useFeatures()?.includes('show_strenuous_difficulty_level');
  if (!result) {
    return null;
  }

  const trail = trailFromAlgoliaTrail(result);

  const onFavoriteClick = trail => {
    logSaveClicked({
      detailed_card_location: 'location page',
      save_location: 'explore',
      map_id: trail.id,
      map_type: 'trail'
    });
    handleFavoriteClick();
  };
  const handleTrailClick = () => {
    logTrailCardClicked({ trail_id: String(result.ID), card_location: 'seo', detailed_card_location: 'map details' });
  };

  return (
    <TrailCardV1
      variant="small"
      languageRegionCode={languageRegionCode}
      onCardClick={handleTrailClick}
      onFavoriteClick={() => onFavoriteClick(trail)}
      isFavorite={isFavorite}
      isCompleted={isCompleted}
      isVerified={isVerified}
      trail={trailFromAlgoliaTrail(result)}
      useMetric={displayMetric}
      lazyLoadImages={true}
      openInNewTab
      isRoundEstTimeToCompletionEnabled={isRoundEstTimeToCompletionEnabled}
      includeStrenuous={showStrenuousDifficultyLevel}
    />
  );
};

export default TrailHoverCard;
